




























import ConnRow from './ConnRow.vue';
export default {
  name: "connectiontable",
  data() {
    return {
      sortedcolumn: 'connid',
      sorteddir: 'asc',
      containerwidth: Math.max(window.innerWidth, 1800),
      containerheight: Math.max(window.innerHeight * (3 / 10), 250)
    }
  },
  computed: {
    columns() {
      return this.$store.getters.getTableHeaders;
    },
    filteredconns() {
      let conns = this.$store.getters.getAllFilteredConns
      if (this.sortedcolumn !== 'connid') {
        conns.sort((a,b) => {
          let modifier = 1
          if (this.sorteddir === 'desc')
            modifier = -1;
            if(a['headerinfo'][this.sortedcolumn] < b['headerinfo'][this.sortedcolumn]) return -1 * modifier;
            if(a['headerinfo'][this.sortedcolumn] > b['headerinfo'][this.sortedcolumn]) return 1 * modifier;
            return 0;
        })
      }
      return conns;   
    }
  },
  methods:{
    sort:function(s) {
      if (s === this.sortedcolumn) {
        this.sorteddir = this.sorteddir==='asc'?'desc':'asc';
      }
      this.sortedcolumn = s;
    },
    filterColumn:function(colname){
      this.$store.dispatch('filterTableHeader', colname)
    },
    handleResize:function(event){
      this.containerwidth = Math.max(window.innerWidth, 1800),
      this.containerheight = Math.max(window.innerHeight * (3 / 10), 250)
    }
  },
  components: {
    ConnRow
  },
  ready: function () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
};
